<template>
</template>

<script>

  // This page handles redirect from legacy links, which included client-side.
  // Yeah really important that this stays in place for a long time.
  // Example of a legacy URL: http://quozio.com/quote/907aaa7e#!t=1014
  // We used the "hash bang" scheme (see below) as it was required in those days for Google to properly spider sites with JavaScript.
  // The value for !t is the selected templateId. Sadly, that is not available on the server side, so we do our best here.

  const parseParams = (params) => {
    var result = {};
    var e,
      a = /\+/g,  // Regex for replacing addition symbol with a space
      r = /([^&;=]+)=?([^&;]*)/g,
      d = function (s) { return decodeURIComponent(s.replace(a, " ")); }

    while (e = r.exec(params))
      result[d(e[1])] = d(e[2]);

    return result;
  }

  const getUrl = (baseUrl, quoteId, templateId, slug) => {
    return `${baseUrl}/quote/${quoteId}/${templateId}/${slug}`;
  }

  export default {
    data() {
      return {
        quote: {}
      };
    },
        head() {
      return {
        title: "Quozio",
      }
    },
    async asyncData(context) {

      // Get the quote.
      let response = await context.app.$dataService.get(`/quotes/${context.params.quoteId}`);
      if (response.error) {
        // If it doesn't exist, bail now.
        return context.error({ statusCode: response.error.status, message: response.error.message });
      }

      // Do you have an escaped fragment in the request? This was used in the legacy application to handle hash bang URLs.
      // The new application does not use hash bangs, and the schema is deprecated, but we have a lot of these links around the web, so this tries to handle them.
      // For example, this URL: http://quozio.com/quote/907aaa7e#!t=1014 would be requested by some bots as http://quozio.com/quote/907aaa7e?_escaped_fragment_=t=1014
      // See https://developers.google.com/search/docs/ajax-crawling/docs/getting-started for more info.

      let frag = context.query["_escaped_fragment_"];
      let templateId = null;

      if (frag) {
        let queryParams = parseParams(frag)
        templateId = queryParams.t;
      }

      // If we have a templateId, do a 301 (permanant) redirect.
      if (templateId) {
        let redirectUrl = getUrl(context.$config.BASE_URL, context.params.quoteId, templateId, response.data.slug);
        return context.redirect(redirectUrl);
      }

      // We don't have a templateId, return to the client side for JavaScript redirect.
      return { quote: response.data };

    },
    mounted() {
      let hashParams = parseParams(window.location.hash.substring(1));
      // You might not have a templateId in the request. In that case, you'll just have to assign a generic one that can stretch.
      let templateId = hashParams["!t"] || "1025";
      window.location.replace(`${this.$config.BASE_URL}/quote/${this.quote.quoteId}/${templateId}/${this.quote.slug}`);
    },
    methods: {
    },
  };
</script>
